import styled from "styled-components";

export const StyledWPMarketsWrapper = styled.div`
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
